const user = {
  state: {
    user: null, // main user logged in
    userStats: null, // main user logged in
    userPref: null, // main user logged in
    userDID: null,
    infoCard: null,
    userActions: null,
    userAccessList: null
  },
  mutations: {
    changeUser(state, payload) {
      state.user = payload;
    },
    changeUserStats(state, payload) {
      state.userStats = payload;
    },
    changeUserPref(state, payload) {
      state.userPref = payload;
    },
    changeUserDID(state, payload) {
      state.userDID = payload;
    },
    changeInfoCard(state, payload) {
      state.infoCard = payload;
    },
    changeUserActions(state, payload) {
      state.userActions = payload;
    },
    changeUserAccessList(state, payload) {
      state.userAccessList = payload;
    }
  },
  actions: {
    changeUser({ commit }, payload) {
      commit("changeUser", payload);
    },
    changeUserStats({ commit }, payload) {
      commit("changeUserStats", payload);
    },
    changeUserPref({ commit }, payload) {
      commit("changeUserPref", payload);
    },
    changeUserDID({ commit }, payload) {
      commit("changeUserDID", payload);
    },
    changeInfoCard({ commit }, payload) {
      commit("changeInfoCard", payload);
    },
    changeUserActions({ commit }, payload) {
      commit("changeUserActions", payload);
    },
    changeUserAccessList({ commit }, payload) {
      commit("changeUserAccessList", payload);
    }
  },
  getters: {
    getUser: state => {
      return state.user;
    },
    getUserStats: state => {
      return state.userStats;
    },
    getUserPref: state => {
      return state.userPref;
    },
    getUserDID: state => {
      return state.userDID;
    },
    getInfoCard: state => {
      return state.infoCard;
    },
    getUserActions: state => {
      return state.userActions;
    },
    getUserAccessList: state => {
      return state.userAccessList;
    }
  }
};
export default user;
